export const concatUrl = (pathname: string, searchParams: URLSearchParams | Record<string, string>): string => {
  const params = new URLSearchParams(searchParams)
  return params.size > 0 ? `${pathname}?${params}` : pathname
}
